export const UNLIMITED_APPROVAL_AMOUNT = 2n ** 256n - 1n
export const UNLIMITED_PERMIT2_AMOUNT = 2n ** 160n - 1n
// As per https://eips.ethereum.org/EIPS/eip-721#specification
export const ERC721_IDENTIFIER = '0x80ac58cd'
